import React, { useEffect, useState } from 'react';
import { Button, Container, Form, Row, Col } from "react-bootstrap";
import Select from "react-select";
import { useNavigate, useParams } from "react-router-dom";
import { BsArrowLeft } from "react-icons/bs";
import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { ring } from 'ldrs';
import Cookies from 'js-cookie';
import { decryptData } from "../../../Auth/cryptage";




function UpdatePermission() {
    const [permissions, setPermissions] = useState([]);
    const [role, setRole] = useState({ name: '', permissions: [] });
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState({ who: '', status: false });
    const { id } = useParams();
    const MySwal = withReactContent(Swal);
    const navigate = useNavigate();
    ring.register();

    const getPermissionsData = async () => {
        try {
            setLoading({ 
                who: 'permissions', 
                status: true 
            });
            const token = decryptData(Cookies.get('access_token'));
            const result = await axios.get('https://api.ai.easysystem.cloud/api/admin/permissions', {
                headers: { 
                    'X-Custom-Token': token 
                }
            });
            if(!result.data.permissions){
                setPermissions([]);
            }else{
                setPermissions(result.data.permissions);
            }
        } catch (error) {
            console.error("Error fetching permissions: ", error);
        } finally {
            setLoading({ who: 'permissions', status: false });
        }
    };

    const getRoleData = async () => {
        try {
            setLoading({ 
                who: "role", 
                status: true 
            });
            const token = decryptData(Cookies.get('access_token'));
            const result = await axios.get(`https://api.ai.easysystem.cloud/api/admin/get-role-permissions/${id}`, {
                headers: { 
                    'X-Custom-Token':token 
                }
            });
            const roleData = result.data.role[0];
            // console.log()(roleData);
            setRole({name:roleData.name,permissions:roleData.permissions.map(permission => ({
                value: permission.id,
                label: permission.name
            }))});
        } catch (error) {
            MySwal.fire({ title: "Error!", text: error.message, icon: "error" });
        } finally {
            setLoading({ 
                who: "role", 
                status: false 
            });
        }
    };

    useEffect(() => {
        getPermissionsData();
        getRoleData();
    }, []);
    
    useEffect(() => {
        setOptions(permissions.map(permission => ({
            value: permission.id,
            label: permission.name
        })));
    }, [permissions]);
    useEffect(() => {
        document.title = "GecimmoIA - Modifier un role";
    }, []);
    const handleChange = (e) => {
        setRole({ ...role, name: e.target.value });
    };
    
    const handleSelectChange = (selectedOptions) => {
        // console.log()(selectedOptions);
        setRole({ ...role, permissions: selectedOptions });
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const token = decryptData(Cookies.get('access_token'));
            // console.log()(role, token);
            setLoading({ who: "submit", status: true });
        
            await axios.put(`https://api.ai.easysystem.cloud/api/admin/update-role/${id}`, {
                name: role.name,
                permissions: role.permissions.map(permission => permission.value)
            }, {
                headers: { 
                    'X-Custom-Token': token 
                }
            });
        
            MySwal.fire({ title: "Success!", text: "role updated successfully", icon: "success" });
            navigate(-1);
        } catch (error) {
            if (error.response && error.response.status === 422) {
                // console.log()('Validation Errors:', error.response.data.errors);
                MySwal.fire({ title: "Error!", text: 'Validation failed. Please check the form inputs.', icon: "error" });
            } else {
                MySwal.fire({ title: "Error!", text: error.message, icon: "error" });
            }
        } finally {
            setLoading({ who: "submit", status: false });
        }
        
    };

    const back = () => {
        navigate(-1);
    };

    return (
        <Container fluid className="d-flex align-items-center justify-content-center main-container">
            {
                loading.status && loading.who === "role" ?  (
                    <l-ring
                        size="30"
                        stroke="3"
                        bg-opacity="0"
                        speed="2"
                        color="black"
                    />
                ) :(
                    <Col className="justify-content-center">
                        <Row className="justify-content-center w-100 mb-4">
                            <Col xs={12} md={8} lg={6}>
                                <div className="form-container">
                                    <h3 className="createRoleTitle text-center mb-5">Modifier une role</h3>
                                    <Form onSubmit={handleSubmit}>
                                        <Form.Group className="mb-4 w-100" controlId="permission_name">
                                            <Form.Label>Nom de role</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="role_name"
                                                size="lg"
                                                value={role.name}
                                                onChange={handleChange}
                                                required
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-4 w-100" controlId="permissions">
                                            <Form.Label>Les permissions</Form.Label>
                                            <Select
                                                name="permissions"
                                                options={options}
                                                isMulti
                                                value={role.permissions}
                                                onChange={handleSelectChange}
                                                placeholder={loading.status && loading.who === "permissions" ? (
                                                    <l-ring
                                                        size="30"
                                                        stroke="3"
                                                        bg-opacity="0"
                                                        speed="2"
                                                        color="black"
                                                    />
                                                ) : "Choisissez les permissions"}
                                                className="basic-multi-select"
                                                classNamePrefix="select"
                                            />
                                        </Form.Group>
                                        <Button
                                            className="mb-4 w-100 gradient-custom-4"
                                            size="lg"
                                            type="submit"
                                        >
                                            {loading.status && loading.who === "submit" ? (
                                                <l-ring-2
                                                    size="25"
                                                    stroke="3"
                                                    stroke-length="0.25"
                                                    bg-opacity="0.1"
                                                    speed="0.8"
                                                    color="white"
                                                />
                                            ) : 'Modifier'}
                                        </Button>
                                        <Button className="backbtn btn-danger mb-4 w-100" onClick={back} size="lg">
                                            <BsArrowLeft className="btnbackIcon" />
                                            Back
                                        </Button>
                                    </Form>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                )
            }
        </Container>
    );
}

export default UpdatePermission;
